import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GlobalService } from '../_services/global.service';
import { LoginService } from '../_services/login.service';
import { CampaignService } from '../_services/campaign.service';
@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {

  email: string = ''
  urlParameter: any = {}
  successfullyUnsubscribed: boolean = false;
  afterUnsubscribeText: string = 'Something went wrong';
  unauthorized: boolean = false;

  constructor(private activatedRoute: ActivatedRoute, private loginService: LoginService, private campaignService: CampaignService) { }

  ngOnInit() {
    this.urlParameter = this.activatedRoute.snapshot.queryParams;
    if (this.urlParameter?.address) {
      this.email = GlobalService.decryptData(this.urlParameter?.address);
    }

    let data = { agent: window.navigator.userAgent };
    this.loginService.ontheflytoken(data)
      .subscribe((res: any) => {
        if (res.message && res.message.token) {
          // save token in local storage
          sessionStorage.setItem('token', res.message.token);

          // save current time in local storage
          sessionStorage.setItem('emit', `${+new Date()}`);

        } else {
          console.log('Something went wrong');
        }
      });
  }

  /**
   * unsubscribe email
   */
  onClickUnsubscribe() {
    this.campaignService.unsubscribe(this.urlParameter).subscribe((res:any)=>{
      if(res && res.statusCode == 200){
        this.successfullyUnsubscribed = true;
        this.afterUnsubscribeText = 'You have successfully Unsubscribed.'; 
      }
    }, (error)=>{
      if(error.error && error.status === 409){
        this.afterUnsubscribeText = 'Email has been already Unsubscribed.';
        this.successfullyUnsubscribed = true
      }
      if(error.error && error.status === 401){
        this.successfullyUnsubscribed = true;
        this.unauthorized = true;
        this.afterUnsubscribeText = 'Some thing went wrong.';
      }
      if(error.error && error.status === 500){
        this.successfullyUnsubscribed = true
        this.afterUnsubscribeText = 'Internal server error';
      }
    })
  }
}
